export class PurchaseOrderLine {
    id:number = 0;
    purchase_order_id:number = 0;
    article_id:number = 0;
    article_name:string = '';
    description:string = '';
    quantity:number = 0;
    missing_quantity:number = 0;
    unit_price:number = 0;
    iva:number = 0.16;
    unity_id:number = null;
    unity:string = '';
    unity_detail:string = '';
    status:string = 'Creada';
    selected:boolean = false;
    requisition_line_id:number = null;
    requisition_id:number = null;
    customer_id:number = null; 
    customer_name:string = '';
    measure_unit:string = ''; 
    discount:number = 0;
    warehouse_measure_unit:string = '';
    warehouse_factor:number = 1;
    is_sap:boolean = false;
    item_code_sap:string = '';
    item_name_sap:string = '';
    comments:string = '';
}
